module.exports = __webpack_public_path__ + "img/zoom-icon.e638a9a7.svg";